import { Type } from 'class-transformer';
import { VendorHeaderTemplateRawDto } from './vendor-header-template-raw-dto';
import { VendorLineItemTemplateRawDto } from './vendor-lineItem-template-raw-dto';

export class VendorTemplateResultDto {
    @Type(() => VendorHeaderTemplateRawDto)
    headerTemplate: VendorHeaderTemplateRawDto;

    @Type(() => VendorLineItemTemplateRawDto)
    lineItemTemplates: Array<VendorLineItemTemplateRawDto>;

    hasAccountLevelTemplates: boolean; // 	NOTE: Indicates if there is at least one vendor account with templates
}
